import ReactSelect from "react-select";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CustomDropdownIndicator } from "../../Home/components/CustomDropdownIndicator";
import { updateAskVyrillState } from "../Actions";
import { getDateString } from "../../../utilities";
import { dateRangeDurations } from "../../../constants";

const style = {
  control: (provided, state) => ({
    ...provided,
    paddingLeft: "2px",
    paddingRight: "25px",
    position: "reletive",
    maxWidth: "233px",
    boxShadow: null,
    borderColor: "#C4C4C4",
    backgroundColor: "#FAF9FF",
    cursor: "pointer",
    minHeight: "22px",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#FAF9FF",
    marginTop: "0px",
    borderRadius: "10px",
    width: "233px",
  }),

  valueContainer: (provided) => ({
    ...provided,
    padding: "0 5px",
  }),

  option: (provided, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...provided,
      cursor: "pointer",
      color: isSelected ? "#7237c6" : "black",
      backgroundColor: "#FAF9FF",
      borderBottom: "0.2px solid #C7C6C6",
    };
  },
  dropdownIndicator: (provided, state) => ({
    ...provided,
    position: "absolute",
    right: "2px",
    top: "3px",
  }),
};
const durations = {
  today: "Today",
  "1d": "1 day",
  "1w": "1 week",
  "1m": "1 month",
  "3m": "3 month",
  "6m": "6 month",
  ytd: "YTD",
  "1y": "1 year",
  all_dates: "All Dates",
  custom: "Custom Date",
};

const generatePlatForm = (data) => {
  return data?.map((k) => ({
    value: k,
    label: (
      <div className="d-flex align-items-center">
        <div
          style={{ minWidth: "44px", fontSize: "12px", marginRight: "10px" }}
        >
          {durations[k]}
        </div>
        <div style={{ fontSize: "10px", color: "#6B727A" }}>
          {getDateString(k)}
        </div>
      </div>
    ),
  }));
};
const AskVyrillDuration = ({ customStyles }) => {
  const askVyrillDuration = useSelector(
    (state) => state.askVyrill.askVyrillDuration
  );
  const dispatch = useDispatch();

  const handleChange = (selectedOption) => {
    dispatch(
      updateAskVyrillState({
        askVyrillDuration: selectedOption,
      })
    );
  };
  useEffect(() => {
    const defaultDuration = generatePlatForm([askVyrillDuration?.value])[0];
    handleChange(defaultDuration);
  }, []);

  return (
    <ReactSelect
      options={generatePlatForm(dateRangeDurations)}
      onChange={handleChange}
      styles={{ ...style, ...customStyles }}
      value={askVyrillDuration}
      components={{
        DropdownIndicator: CustomDropdownIndicator,
        IndicatorSeparator: () => null,
      }}
    />
  );
};
export default AskVyrillDuration;
